import React from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const BreadCrumb = ({ items = [], sidebarWidth = 0 }) => {
  const navigate = useNavigate();

  const breadCrumBg = useColorModeValue('gray.200', 'navy.700');
  const activeTabColor = useColorModeValue('gray.700', 'white');

  return (
    <Breadcrumb
      mb={6}
      fontWeight="bold"
      fontSize="sm"
      color={activeTabColor}
      backgroundColor={breadCrumBg}
      padding={2}
      borderRadius="md"
      width="fit-content"
      separator=">"
      ml={sidebarWidth}
      transition="margin-left 0.3s ease"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <BreadcrumbItem key={index} isCurrentPage={isLast}>
            {isLast ? (
              <Text color="gray.400" fontWeight="bold">
                {item.label}
              </Text>
            ) : (
              <Text
                cursor="pointer"
                _hover={{ textDecoration: 'underline' }}
                onClick={() => item.path && navigate(item.path)}
              >
                {item.label}
              </Text>
            )}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

export default BreadCrumb;
